export enum AccountSourceType {
    CROSS = '448b2e97-0fef-4c79-9f00-cbd92c57029a'
}
